import "./Loading.css";
const Loading = () => {
  return (
    <div className="loading loading07">
      <span data-text="u">u</span>
      <span data-text="n">n</span>
      <span data-text="a">a</span>
    </div>
  )
}

export default Loading;